import { render, staticRenderFns } from "./ImageResources.vue?vue&type=template&id=1966f994&scoped=true"
import script from "./ImageResources.vue?vue&type=script&lang=js"
export * from "./ImageResources.vue?vue&type=script&lang=js"
import style0 from "./ImageResources.vue?vue&type=style&index=0&id=1966f994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1966f994",
  null
  
)

export default component.exports